import { CountryMap } from './Vendor'
import { Address } from './Recipient'

export interface Consumer {
  id: string
  email: string
  firstName: string
  lastName: string
  avatarUrl: string
  phonenumber: string
  homeCountry?: CountryMap
  workCountry?: CountryMap
  address?: Address
}

export const consumerConverter: firebase.firestore.FirestoreDataConverter<Consumer> = {
  toFirestore: consumer => {
    return {
      email: consumer.email,
      firstName: consumer.firstName,
      lastName: consumer.lastName,
      avatarUrl: consumer.avatarUrl,
      phonenumber: consumer.phonenumber,
      homeCountry: consumer.homeCountry,
      workCountry: consumer.workCountry,
      address: consumer.address
    }
  },
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options)
    return {
      id: snapshot.id,
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      avatarUrl: data.avatarUrl,
      phonenumber: data.phonenumber,
      homeCountry: data.homeCountry,
      workCountry: data.workCountry,
      address: data.address
    }
  }
}
